export function findLanguageByTrack(audioTrack) {
  return function (languageTags) {
    return languageTags.find(
      (tag) =>
        /* 16 in en-X-16 */
        (tag.endsWith(`-${audioTrack.id}`) &&
          /* en in en-X */
          tag.startsWith(audioTrack.lang_iso_639_1)) ||
        /* transform en-x-16 to en-16 and compare it with shaka's tag (should be en-16 because of responseProcessor module) */
        tag.toLowerCase() === audioTrack.lang_tag.replace('-x', '') ||
        /*en vs en*/
        tag === audioTrack.lang_iso_639_1
    );
  };
}
